import { create } from 'zustand';
import { FixedArray, OfferingActionItem } from '@ninjacart/nc-nk-core';

type Categories = {
  bell: boolean;
  flower: boolean;
  coconut: boolean;
  aarti: boolean;
};

type DevotionalStoreType = {
  liveChatUserCount?: number;
  setLiveChatUserCount: (count: number) => void;
  isModeratorActive: boolean;
  setIsModeratorActive: (isActive: boolean) => void;
  showAnimatedRing: boolean;
  setShowAnimatedRing: (isActive: boolean) => void;
  categories: Record<string, boolean>;
  setCategory: (key: keyof Categories, value: boolean) => void;
  setAllCategories: (newCategories: Record<string, boolean>) => void;
  subCategoryMessage: string;
  setSubCategoryMessage: (message: string) => void;
  userOfferingCollection: Array<{ id: string; message: string }>;
  setUserOfferingCollection: (item: { id: string; message: string }) => void;
  clearUserOfferingCollection: () => void;
  offeringAction?: string;
  setOfferingAction: (actionKind: string) => void;
};

export const useDevotionalStore = create<DevotionalStoreType>()((set, get) => ({
  liveChatUserCount: get()?.liveChatUserCount ?? 0,
  setLiveChatUserCount: (count: number) =>
    set((state) => ({
      liveChatUserCount: count,
    })),
  isModeratorActive: false,
  setIsModeratorActive: (isModeratorActive: boolean) => set(() => ({ isModeratorActive })),
  showAnimatedRing: false,
  setShowAnimatedRing: (isActive: boolean) => set(() => ({ showAnimatedRing: isActive })),
  // categories: {
  //   bell: true,
  //   flower: true,
  //   coconut: true,
  //   aarti: true,
  //   tulsi: false,
  //   gangajal: false,
  //   baelpatra: false,
  //   laddu: false,
  //   modak: false,
  //   ghee: false,
  // },
  categories: {},
  setCategory: (key, value) =>
    set((state) => ({
      categories: { ...state.categories, [key]: value },
    })),
  setAllCategories: (newCategories) =>
    set((state) => ({
      categories: newCategories,
    })),
  subCategoryMessage: '',
  setSubCategoryMessage: (message: string) => set(() => ({ subCategoryMessage: message })),
  userOfferingCollection: [],
  setUserOfferingCollection: (item: { id: string; message: string }) => {
    const existing = get()?.userOfferingCollection;
    if (existing.length > 5) {
      existing.shift();
    }
    if (existing?.find((x) => x.id === item?.id)) return;
    set(() => ({ userOfferingCollection: [...existing, item] }));
  },
  clearUserOfferingCollection: () => {
    get().userOfferingCollection.length = 0;
  },
  offeringAction: undefined,
  setOfferingAction: (actionKind: string) => set(() => ({ offeringAction: actionKind })),
}));
